export enum LookUpMappingType {
  Key,
  Value
}
